import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: "",
  showSnackBar: {
    show: false,
    status: "",
  },
};

const interfaceSlice = createSlice({
  name: "bookingOptions",
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setSnackBar(state, action) {
      state.showSnackBar = action.payload;
    },
    // setDuration(state, action) {
    //   state.duration = action.payload;
    // },
    // setSelectedMainCourt(state, action) {
    //   state.mainCourt = action.payload;
    // },
    // setSelectSubCourt(state, action) {
    //   state.subCourt = action.payload;
    // },
    // setTotalPrice(state, action) {
    //   state.totalPrice = action.payload;
    // },
    // setPaymentOption(state, action) {
    //   state.paymentOptions = action.payload;
    // },
  },
});

export const interfaceActions = interfaceSlice.actions;
export default interfaceSlice.reducer;
